import {observer} from 'mobx-react';
import {Link} from 'react-router-dom';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {TimeTrackingSchedule} from 'main/stores/time_tracking';
import {Tag, AvatarList} from 'shared/components';
import {InteractiveTable} from 'main/components';
import {FormattedMessage} from 'react-intl';

const Name = observer(({model}) => {
  const name = model.name ? model.name : <FormattedMessage id='time_tracking.manage.schedules.Untitled schedule'/>;

  return (
    <div>
      <div className='table-cell align-middle'>
        {model.configured ?
          <Link to={`/schedules/${model.id}`} className='dodger TextLink'>{name}</Link> :
          name}
      </div>
      <div className='table-cell align-middle'>
        {!model.configured && <Tag className='ml1'><FormattedMessage id='time_tracking.manage.schedules.directory.Draft'/></Tag>}
      </div>
    </div>
  );
});

const Managers = observer(({model}) => {
  return model.managers.map(manager => manager.name).join(', ');
});

const COLUMNS = [
  {
    header: 'time_tracking.manage.schedules.directory.Schedule name',
    width: 4,
    component: Name
  },
  {
    header: 'time_tracking.manage.schedules.directory.Managers',
    width: 4,
    component: Managers
  },
  {
    header: 'time_tracking.manage.schedules.directory.Employees',
    width: 3,
    render: model => <AvatarList employees={model.employees} moreModalEnabled/>
  }
];

const LOCALIZATION = {
  emptyState: 'time_tracking.manage.schedules.directory.No schedules to display',
  removeModal: {
    header: 'time_tracking.manage.schedules.directory.Remove Schedule?',
    subHeader: 'time_tracking.manage.schedules.directory.Are you sure you want to remove this schedule?'
  },
  interactive: {
    addModel: 'time_tracking.manage.schedules.directory.Create New Schedule'
  }
};

const ScheduleDirectory = observer(({uiState}) => {
  const {canCreateSchedule} = uiState;

  return (
    <InteractiveTable
      title={t('time_tracking.manage.schedules.Schedules')}
      uiState={uiState}
      columns={COLUMNS}
      saveStateToUrl
      showAddButton={canCreateSchedule}
      onMount={agent => uiState.setInteractiveAgent(agent)}
      localization={LOCALIZATION}
      onAdd={() => uiState.createSchedule()}
      onRemove={schedule => uiState.removeSchedule(schedule)}
      editRoute='/schedules/:id/edit'
      proxy={{
        type: 'async',
        modelType: types.TIME_TRACKING.SCHEDULE,
        model: TimeTrackingSchedule,
        endpoint: endpoints.TIME_TRACKING.SCHEDULES.ALL
      }}>
    </InteractiveTable>
  );
});

export default ScheduleDirectory;
